import _ from "lodash";

export const mapArrayToObject = (list) =>
    _.reduce(list, (memo, current) => _.assign(memo, current), {});
